export default {
  form: 'form',
  intro: 'intro',
  review: 'review',
  status: 'status',
  contactMe: 'contactMe'
}
